import { PDFViewer } from "@react-pdf/renderer";
import PrintChallan from "./print-challan.component";

const PDFChallanComponent = (props: any) => {
  return (
    <div>
      <PDFViewer width="1000" height="650" className="app" >
        <PrintChallan data={props.data} />
      </PDFViewer>
    </div>
  );
}

export default PDFChallanComponent;